import { Button, Menu, MenuButton, MenuList, MenuItem, Portal, Icon } from '@chakra-ui/react';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ChevronDownIcon from '@/assets/icons/ic-caret-down.svg';
import CheckMarkIcon from '@/assets/icons/ic-check-mark.svg';

import { IOptionItem } from '@/components/ui/shared/hubs/HubsPageActions/components/types';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const HubsSortDropdown: FC<{ options: Array<IOptionItem>; defaultOption: string }> = ({
  options,
  defaultOption,
}) => {
  const { t } = useTranslation();
  const { sort = defaultOption, change } = useQueryParams<{ sort: string }>({
    sort: StringParam,
  });

  const selectedOption = useMemo(() => options.find((item) => item.value === sort), [options, sort]);

  return (
    <Menu flip={false}>
      <MenuButton
        w={{ base: 'full', md: 'auto' }}
        as={Button}
        variant="menu"
        size="sm"
        rightIcon={<ChevronDownIcon />}
        _hover={{ bgColor: 'violet.500', color: 'white' }}
        _active={{ bgColor: 'violet.500', color: 'white' }}
      >
        {t('common.sortBy')} {selectedOption ? t(`sort.${selectedOption.label}`) : t('sort.default')}
      </MenuButton>
      <Portal>
        <MenuList maxH="224px" overflow="auto">
          {options?.map((option) => (
            <MenuItem
              key={option.value}
              onClick={() => {
                change({ sort: option.value }, { shallow: true });
              }}
            >
              {t(`sort.${option.label}`)}
              {(!selectedOption && option.value === null) || selectedOption?.value === option.value ? (
                <Icon as={CheckMarkIcon} color="violet.500" ml="auto" />
              ) : null}
            </MenuItem>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  );
};
